import { render, staticRenderFns } from "./PersonEntryList.vue?vue&type=template&id=705a5c06"
import script from "./PersonEntryList.vue?vue&type=script&lang=js"
export * from "./PersonEntryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports